import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="relative bg-[#1E3A47] overflow-hidden">
      {/* Top wave separator */}
      <div className="absolute top-0 left-0 right-0 -translate-y-[99%]">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto block">
          <path d="M0 60V20C240 60 480 0 720 20C960 40 1200 60 1440 20V60H0Z" fill="#1E3A47" />
        </svg>
      </div>

      {/* CTA banner */}
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto pt-20 md:pt-24 pb-10 md:pb-14">
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-6 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-2">
              Besoin d'une réparation ?
            </h3>
            <p className="text-white/70 text-sm md:text-base">
              Devis gratuit sous 24h. Intervention dans tout le Bas-Rhin.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://wa.me/33745883392"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3.5 rounded-xl font-semibold text-sm whitespace-nowrap hover:bg-[#1EBE5D] transition-colors shadow-lg shadow-[#25D366]/20"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.447-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp
            </a>
            <a
              href="tel:0374471036"
              className="inline-flex items-center justify-center gap-2 bg-[#FF6B4A] text-white px-6 py-3.5 rounded-xl font-semibold text-sm whitespace-nowrap hover:bg-[#FF6B4A]/90 transition-colors shadow-lg shadow-[#FF6B4A]/20"
            >
              <i className="ri-phone-line" />
              03 74 47 10 36
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-white px-6 py-3.5 rounded-xl font-semibold text-sm whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              <i className="ri-edit-line" />
              Devis gratuit
            </a>
          </div>
        </div>
      </div>

      {/* Main footer grid */}
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto pb-12">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 md:gap-6">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4">
            <a href="/" className="inline-flex items-center mb-4">
              <Logo variant="footer" />
            </a>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs mb-6">
              Réparation de fenêtre et mécanismes à Strasbourg et dans le Bas-Rhin. Devis gratuit, pièce comprise.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                <i className="ri-shield-check-line text-[#FF6B4A]" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Garantie 10 ans</p>
                <p className="text-white/50 text-xs">Sur toutes les pièces</p>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-2">
              <i className="ri-tools-line text-[#FF6B4A]" />
              Services
            </h4>
            <ul className="space-y-2.5">
              {[
                ["Réglage oscillo-battant", "/reglage-fenetre-oscillo-battant"],
                ["Oscillo-battant bloqué", "/fenetre-oscillo-battant-bloquee"],
                ["Crémone", "/cremone-fenetre"],
                ["Poignée", "/poignee-fenetre-bloquee"],
                ["Gond & paumelle", "/gond-paumelle-fenetre"],
                ["Fenêtre qui ferme mal", "/fenetre-ferme-mal"],
                ["PVC", "/fenetre-pvc"],
                ["Alu", "/fenetre-alu"],
                ["Bois", "/fenetre-bois"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="text-white/60 text-sm hover:text-white transition-colors inline-flex items-center gap-1.5 group">
                    <span className="w-1 h-1 rounded-full bg-[#FF6B4A]/50 group-hover:bg-[#FF6B4A] transition-colors" />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Zones */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-2">
              <i className="ri-map-pin-line text-[#FF6B4A]" />
              Zones
            </h4>
            <ul className="space-y-2.5">
              {[
                ["Strasbourg", "/"],
                ["Haguenau", "/reparation-fenetre-haguenau"],
                ["Schiltigheim", "/reparation-fenetre-schiltigheim"],
                ["Illkirch", "/reparation-fenetre-illkirch-graffenstaden"],
                ["Sélestat", "/reparation-fenetre-selestat"],
                ["Bischheim", "/reparation-fenetre-bischheim"],
                ["Lingolsheim", "/reparation-fenetre-lingolsheim"],
                ["Bischwiller", "/reparation-fenetre-bischwiller"],
                ["Saverne", "/reparation-fenetre-saverne"],
                ["Obernai", "/reparation-fenetre-obernai"],
                ["Ostwald", "/reparation-fenetre-ostwald"],
                ["Hœnheim", "/reparation-fenetre-hoenheim"],
                ["Toutes les zones", "/zones-dinterventions"],
              ].map(([label, href]) => (
                <li key={href + label}>
                  <a href={href} className="text-white/60 text-sm hover:text-white transition-colors inline-flex items-center gap-1.5 group">
                    <span className="w-1 h-1 rounded-full bg-[#FF6B4A]/50 group-hover:bg-[#FF6B4A] transition-colors" />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Légal */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-2">
              <i className="ri-file-list-line text-[#FF6B4A]" />
              Légal
            </h4>
            <ul className="space-y-2.5">
              {[
                ["Qui sommes-nous", "/qui-sommes-nous"],
                ["Tarifs", "/tarifs"],
                ["Avis clients", "/avis"],
                ["Mentions légales", "/mentions-legales"],
                ["Confidentialité", "/politique-confidentialite"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="text-white/60 text-sm hover:text-white transition-colors inline-flex items-center gap-1.5 group">
                    <span className="w-1 h-1 rounded-full bg-[#FF6B4A]/50 group-hover:bg-[#FF6B4A] transition-colors" />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1 md:col-span-2">
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-2">
              <i className="ri-phone-line text-[#FF6B4A]" />
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-[#FF6B4A] text-sm" />
                </div>
                <div>
                  <a href="tel:0374471036" className="text-white text-sm font-semibold hover:text-[#FF6B4A] transition-colors">
                    03 74 47 10 36
                  </a>
                  <p className="text-white/50 text-xs mt-0.5">Lun–Sam 8h–18h</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-[#FF6B4A] text-sm" />
                </div>
                <div>
                  <p className="text-white text-sm">82 rue de Heidenberg</p>
                  <p className="text-white/60 text-sm">67200 Strasbourg</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-[#FF6B4A] text-sm" />
                </div>
                <div>
                  <a href="mailto:info@reparation-fenetre-strasbourg.fr" className="text-white text-sm hover:text-[#FF6B4A] transition-colors">
                    info@reparation-fenetre-strasbourg.fr
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto py-6 border-t border-white/10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center sm:text-left">
            © 2026 DF PRO — Réparation Fenêtre Strasbourg. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a href="/mentions-legales" className="text-white/40 text-xs hover:text-white transition-colors">
              Mentions légales
            </a>
            <a href="/politique-confidentialite" className="text-white/40 text-xs hover:text-white transition-colors">
              Politique de confidentialité
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}